import { Button, CheckIcon, MenuItem, PlusIcon, Select, Stack, Typography } from '@customink/pigment-react';
import { SelectChangeEvent } from '@mui/material';
import { useCallback, useState } from 'react';
import { getAccountIdQueryVariable } from '~/adapters/browser/getAccountIdQueryVariable';
import { useSetQueryParam } from '~/adapters/browser/useSetQueryParam';
import { Account } from '~/adapters/services/accounts/accounts/types';
import { useUserAccounts } from '~/adapters/services/accounts/users/hooks';
import { useUserAccount } from '~/contexts/UserAccount/UserAccountContext';

const AccountSelector: React.FC = () => {
    const { user: userData } = useUserAccount();
    const { data: accounts } = useUserAccounts();
    const setQueryParam = useSetQueryParam();
    const accountIdFromQuery = getAccountIdQueryVariable();

    const [accountId, setAccountId] = useState<string>(accountIdFromQuery ?? userData.id.toString());

    const handleSelectChange = useCallback(async (e: SelectChangeEvent) => {
        const { value } = e.target;
        setAccountId(value);
        setQueryParam('accountId', value);
        window.location.reload();
    }, []);

    const getDefaultAccountLabel = (account: Account): string =>
        account.personal ? `Personal #${account.id}` : `Team #${account.id}`;

    return (
        <Typography variant="h5" sx={{ fontWeight: 400 }}>
            {(accounts ?? []).length > 1 ? (
                <Select
                    fullWidth
                    value={accountId}
                    onChange={handleSelectChange}
                    renderValue={(val) => {
                        const selectedAccount = accounts?.find((acc) => acc.id === +val) as Account;
                        return selectedAccount.name ?? getDefaultAccountLabel(selectedAccount);
                    }}
                >
                    {accounts?.map((account) => (
                        <MenuItem key={account.id} value={account.id}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                {account.name ?? getDefaultAccountLabel(account)}
                                {accountId === account.id.toString() && <CheckIcon fontSize="small" />}
                            </Stack>
                        </MenuItem>
                    ))}
                </Select>
            ) : (
                <Button variant="secondary" startIcon={<PlusIcon />}>
                    Create team
                </Button>
            )}
        </Typography>
    );
};

export default AccountSelector;
